import { getLogger } from "@expert/logging";
import { expertWorkspaceWebSocketEventBus } from "@expert/websocket";
import { useEffect } from "react";
import { AutopilotState, useChatStore } from "@/sdk/agent/chat";
import { userCache } from "@/shared-utils";

const logger = getLogger({
    module: "useAutopilotEventsListener",
    supportTeam: "messaging",
});

export interface AutopilotEventPayload {
    chatId: string;
    expertEmployeeId: string;
    durationSeconds?: number;
    startTime?: number;
    endTime?: number;
}

export const useAutopilotEventsListener = () => {
    useEffect(() => {
        return expertWorkspaceWebSocketEventBus.on("ws_chat-autopilot-event", (payload: AutopilotEventPayload) => {
            logger.info({ autopilotEventPayload: JSON.stringify(payload) }, "Autopilot event received");

            const { chatId, expertEmployeeId, startTime, durationSeconds, endTime } = payload;
            if (expertEmployeeId !== userCache.employeeId) {
                logger.info(
                    { expertEmployeeId, userCacheEmployeeId: userCache.employeeId },
                    "Ignoring autopilot event for different expert",
                );
                return;
            }

            const updateData: Partial<AutopilotState> = { endTime: endTime ? new Date(endTime) : undefined };
            if (startTime) {
                updateData.startTime = new Date(startTime);
            }
            if (durationSeconds) {
                updateData.durationSeconds = durationSeconds;
            }
            useChatStore.getState().updateChatAutopilot(chatId, updateData);
        });
    }, []);
};
